// import React, { useEffect } from 'react';
// import './SectionServe.scss';
// import ig1 from '../../../assets/images/graf1.png';
// import ig2 from '../../../assets/images/graf2.png';
// import ig3 from '../../../assets/images/gtaf3.png';
// import ig4 from '../../../assets/images/graf4.png';
// import ig5 from '../../../assets/images/graf5.png';
// import ig6 from '../../../assets/images/graf6.png';
// import img1 from '../../../assets/images/frame22.png';
// import img2 from '../../../assets/images/frame23.png';
// import img3 from '../../../assets/images/frame24.png';
// import img4 from '../../../assets/images/frame25.png';
// import img5 from '../../../assets/images/frame26.png';
// import img6 from '../../../assets/images/frame27.png';
// import { Flex, Image, Card, Row, Col } from 'antd';
// import { Swiper, SwiperSlide } from 'swiper/react';
// import 'swiper/css';
// import Aos from 'aos';
// const SectionServe = ({ t, data, isLoading }) => {
//   useEffect(() => {
//     Aos.init({
//       duration: 1000,
//     });
//   }, []);
//   console.log(data, 'data from serve');

//   const services = [
//     {
//       img: img4,
//       img2: ig4,
//       title: t.Manufacturingsimulations,
//       description: t.descriptionServeCard4,
//       // boxShadow:" 0px 10px 40px 0 rgb(255, 255, 255, 0.25)"
//       boxShadow: ' rgba(255, 255, 255, 0.25) 0px 13px 20px 0px',
//     },
//     {
//       img: img1,
//       img2: ig1,
//       title: t.HealthCare,
//       description: t.descriptionServeCard1,
//       // boxShadow:" 0px 10px 40px 0 rgba(210, 15, 102, 0.25)"
//       boxShadow: ' rgba(210, 15, 102, 0.25) 0px 13px 20px 0px',
//     },
//     {
//       img: img5,
//       img2: ig5,
//       title: t.Education,
//       description: t.descriptionServeCard5,
//       // boxShadow:" 0px 10px 40px 0 rgb(0, 71, 224,0.25)"
//       boxShadow: ' rgba(0, 71, 224,0.25) 0px 13px 20px 0px',
//     },
//     {
//       img: img2,
//       img2: ig2,
//       // title: t.Employeestrainings,
//       title: t.TrainingSimulation,
//       description: t.descriptionServeCard2,
//       // boxShadow:" 0px 10px 40px 0 rgb(63, 230, 255, 0.25)"
//       boxShadow: ' rgba(63, 211, 208, 0.25) 0px 13px 20px 0px',
//     },
//     {
//       img: img3,
//       img2: ig3,
//       title: t.Corporateinnovation,
//       description: t.descriptionServeCard3,
//       // boxShadow:" 0px 10px 40px 0 rgb(197, 201, 0 , 0.25)"
//       boxShadow: ' rgba(197, 201, 0, 0.25) 0px 13px 20px 0px',
//     },

//     {
//       img: img6,
//       img2: ig6,
//       title: t.MilitaryandDefense,
//       description: t.descriptionServeCard6,
//       // boxShadow:" 0px 10px 40px 0 rgb(110, 110, 110)"
//       boxShadow: ' rgba(110, 110, 110, 0.25) 0px 13px 20px 0px',
//     },
//   ];
//   return (
//     <section className="section-Serve">
//       <div className="content">
//         <h1 className="title-Serve" data-aos="fade-right">
//           {t.PotentialIndustriesweserve}
//         </h1>
//         <div className="service-cards" data-aos="fade-up">
//           <Row gutter={[20, 20]}>
//             {services?.map((service, index) => (
//               <Col xs={24} sm={24} md={12} lg={12} xl={8} key={index}>
//                 <Card
//                   key={index}
//                   className="card-Serve"
//                   data-aos={index % 2 ? 'fade-right' : 'fade-left'}
//                   data-aos-delay={index * 10}
//                 >
//                   <Flex
//                     align="start"
//                     justify="start"
//                     style={{
//                       width: '100%',
//                       height: '100%',
//                       flexDirection: 'column',
//                     }}
//                     gap={10}
//                   >
//                     <div
//                       className="img"
//                       style={{
//                         backgroundImage: `url(${
//                           service?.img2 ? service?.img : ''
//                         })`,
//                         boxShadow: service?.boxShadow,
//                       }}
//                     >
//                       <Image
//                         preview={false}
//                         src={service?.img2 ? service?.img2 : service?.img}
//                         alt=""
//                       />
//                     </div>
//                     <h1 className="title-card-Serve">{service?.title}</h1>
//                     <p className="description-card-Serve">
//                       {service?.description}
//                     </p>
//                   </Flex>
//                 </Card>
//               </Col>
//             ))}
//           </Row>
//         </div>
//         <div className="swiper-serve">
//           <Swiper
//             spaceBetween={20}
//             slidesPerView={1.2}
//             scrollbar={{
//               draggable: true,
//             }}
//           >
//             <Row gutter={[20, 20]}>
//               {services?.map(
//                 (service, _id) =>
//                   service && (
//                     <SwiperSlide key={_id}>
//                       <Col xs={24} sm={24} md={12} lg={12} xl={8}>
//                         <Card className="card-Serve">
//                           <Flex
//                             align="start"
//                             justify="start"
//                             style={{
//                               width: '100%',
//                               height: '100%',
//                               flexDirection: 'column',
//                             }}
//                             gap={10}
//                           >
//                             <div
//                               className="img"
//                               style={{
//                                 backgroundImage: `url(${
//                                   service?.img2 ? service?.img : ''
//                                 })`,
//                                 boxShadow: service?.boxShadow,
//                               }}
//                             >
//                               <Image
//                                 preview={false}
//                                 src={
//                                   service?.img2 ? service?.img2 : service?.img
//                                 }
//                                 alt=""
//                               />
//                             </div>
//                             <h1 className="title-card-Serve">
//                               {service?.title}
//                             </h1>
//                             <p className="description-card-Serve">
//                               {service?.description}
//                             </p>
//                           </Flex>
//                         </Card>
//                       </Col>
//                     </SwiperSlide>
//                   )
//               )}
//             </Row>
//           </Swiper>
//         </div>
//       </div>
//     </section>
//   );
// };

// export default SectionServe;
import React, { useEffect } from 'react';
import './SectionServe.scss';
import { Flex, Image, Card, Row, Col, Skeleton } from 'antd'; // Import Skeleton
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
import Aos from 'aos';

const SectionServe = ({ t, data, isLoading }) => {
  useEffect(() => {
    Aos.init({
      duration: 1000,
    });
  }, []);

  // Function to determine boxShadow based on index or other criteria (optional)
  const getBoxShadow = (index) => {
    const shadows = [
      'rgba(255, 255, 255, 0.25) 0px 13px 20px 0px', // Example shadow 1
      'rgba(210, 15, 102, 0.25) 0px 13px 20px 0px', // Example shadow 2
      'rgba(0, 71, 224, 0.25) 0px 13px 20px 0px', // Example shadow 3
      'rgba(63, 211, 208, 0.25) 0px 13px 20px 0px', // Example shadow 4
      'rgba(197, 201, 0, 0.25) 0px 13px 20px 0px', // Example shadow 5
      'rgba(110, 110, 110, 0.25) 0px 13px 20px 0px', // Example shadow 6
    ];
    return shadows[index % shadows.length];
  };

  // Create an array for skeleton loading cards
  const loadingCards = Array.from({ length: 6 }).map((_, index) => (
    <Col xs={24} sm={24} md={12} lg={12} xl={8} key={`loading-${index}`}>
      <Card className="card-Serve loading-card">
        {' '}
        {/* Add a loading-card class for potential styling */}
        <Flex
          align="start"
          justify="start"
          style={{
            width: '100%',
            height: '100%',
            flexDirection: 'column',
          }}
          gap={10}
        >
          <div className="img">
            <Skeleton.Image active style={{ width: '100%', height: '150px' }} />{' '}
            {/* Skeleton for image */}
          </div>
          <h1 className="title-card-Serve">
            <Skeleton active paragraph={{ rows: 1 }} />{' '}
            {/* Skeleton for title */}
          </h1>
          <p className="description-card-Serve">
            <Skeleton active paragraph={{ rows: 3 }} />{' '}
            {/* Skeleton for description */}
          </p>
        </Flex>
      </Card>
    </Col>
  ));

  return (
    <section className="section-Serve">
      <div className="content">
        <h1 className="title-Serve" data-aos="fade-right">
          {t.PotentialIndustriesweserve}
        </h1>
        {/* <div className="service-cards" data-aos="fade-up">
          <Row gutter={[20, 20]}>
         
            {isLoading
              ? loadingCards
              : data?.map((service, index) => (
                  <Col xs={24} sm={24} md={12} lg={12} xl={8} key={index}>
                 
                    <Card
                      key={index}
                      className="card-Serve"
                      data-aos={index % 2 ? 'fade-right' : 'fade-left'}
                      data-aos-delay={index * 10}
                    >
                      <Flex
                        align="start"
                        justify="start"
                        style={{
                          width: '100%',
                          height: '100%',
                          flexDirection: 'column',
                        }}
                        gap={10}
                      >
                        <div
                          className="img"
                          style={{
                            // backgroundImage: `url(${service?.image})`, // Use dynamic image from data
                            boxShadow: getBoxShadow(index), // Apply dynamic boxShadow
                          }}
                        >
                          <Image
                            preview={false}
                            src={service?.image}
                            alt={service?.title}
                            // style={{
                            //   backgroundRepeat: 'no-repeat',
                            //   backgroundSize: 'cover',
                            //   objectFit: 'contain',
                            // }}
                          />
                        </div>
                        <h1 className="title-card-Serve">{service?.title}</h1>
                        <p className="description-card-Serve">
                          {service?.description}
                        </p>
                      </Flex>
                    </Card>
                  </Col>
                ))}
          </Row>
        </div> */}
        <div
          className="service-cards"
          data-aos="fade-up"
          style={{
            display: 'grid',
            gap: '20px',
            gridTemplateColumns:
              data?.length === 2
                ? 'repeat(2, 1fr)'
                : data?.length === 3
                ? 'repeat(3, 1fr)'
                : data?.length === 4
                ? 'repeat(4, 1fr)'
                : data?.length >= 5
                ? 'repeat(3, 1fr)'
                : 'repeat(1, 1fr)',
          }}
        >
          {isLoading
            ? 
            <Row gutter={[20, 20]}>
              {loadingCards}
            </Row>
            : data?.map((service, index) => (
                <Card
                  key={index}
                  className="card-Serve"
                  data-aos={index % 2 ? 'fade-right' : 'fade-left'}
                  data-aos-delay={index * 10}
                >
                  <Flex
                    align="start"
                    justify="start"
                    style={{
                      width: '100%',
                      height: '100%',
                      flexDirection: 'column',
                    }}
                    gap={10}
                  >
                    <div
                      className="img"
                      // style={{
                      //   boxShadow: getBoxShadow(index),
                      // }}
                    >
                      <Image
                        preview={false}
                        src={service?.image}
                        alt={service?.title}
                      />
                    </div>
                    <h1 className="title-card-Serve">{service?.title}</h1>
                    <p className="description-card-Serve">
                      {service?.description}
                    </p>
                  </Flex>
                </Card>
              ))}
        </div>

        {/* The Swiper section will also use dynamic data or loading state */}
        <div className="swiper-serve">
          <Swiper
            spaceBetween={20}
            slidesPerView={1.2}
            scrollbar={{
              draggable: true,
            }}
          >
            {isLoading
              ? loadingCards.map((card, index) => (
                  <SwiperSlide key={`swiper-loading-${index}`}>
                    {card} {/* Reuse the loading card component */}
                  </SwiperSlide>
                ))
              : data?.map(
                  (service, index) =>
                    service && (
                      <SwiperSlide key={index}>
                        <Col xs={24} sm={24} md={12} lg={12} xl={8}>
                          <Card className="card-Serve">
                            <Flex
                              align="start"
                              justify="start"
                              style={{
                                width: '100%',
                                height: '100%',
                                flexDirection: 'column',
                              }}
                              gap={10}
                            >
                              <div
                                className="img"
                                // style={{
                                //   // backgroundImage: `url(${service?.image})`, // Use dynamic image
                                //   boxShadow: getBoxShadow(index), // Apply dynamic boxShadow
                                // }}
                              >
                                <Image
                                  preview={false}
                                  src={service?.image} // Use dynamic image
                                  alt={service?.title}
                                />
                              </div>
                              <h1 className="title-card-Serve">
                                {service?.title}
                              </h1>
                              <p className="description-card-Serve">
                                {service?.description}
                              </p>
                            </Flex>
                          </Card>
                        </Col>
                      </SwiperSlide>
                    )
                )}
          </Swiper>
        </div>
      </div>
    </section>
  );
};

export default SectionServe;
